'use strict';

import angular from 'angular';
import EditConfController from './editConf.controller';

export default angular.module('onyxReadingRoomApp.appstore.editconf', [])
  .controller('AppStoreEditConfController', EditConfController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appstore/editConf/index.js